module.exports = __webpack_public_path__ + "themes/custom/iidb/dist/img/logo-asp-en.8e409799.svg";